import { render, staticRenderFns } from "./No01.vue?vue&type=template&id=6ed67a7a&scoped=true"
import script from "./No01.vue?vue&type=script&lang=js"
export * from "./No01.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed67a7a",
  null
  
)

export default component.exports